export const normalizeDuplicateName = (firstName: string, lastName: string) =>
  `${firstName}${lastName}`.toLowerCase().replace(/\s+/g, "");
